<template lang="pug" src="./users.pug"></template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['roleName']),
    },
    methods: {
        canShowTab(tabName) {
            const tabs = {
                default: ['drivers', 'clients', 'operators'],
                operator: ['drivers', 'clients'],
                'corporate-admin': ['operators'],
                accountant: ['drivers'],
                boss: ['drivers'],
                manager: ['drivers'],
                'admin-delivery': ['operators'],
                'admin-establishment': ['operators']
            };

            const availableTabs = tabs[this.roleName] || tabs.default;
            return this.roleName && availableTabs.includes(tabName);
        }
    }
};
</script>
